<template>
  <v-container>
    <h1>{{ $t('Setting') }}</h1>
    <v-divider />
    <v-layout wrap class="my-3">
      <v-flex xs6>{{ $t('resend_to_the_same_person_if_they_are_in_the_area') }}</v-flex>
      <v-flex xs6 class="text-xs-right">
        <ToggleButton
          :value="!update_timestamp_beacon_not_reply_with_in_second"
          :sync="true"
          :color="$vuetify.theme.success"
          :labels="{ checked: 'ON', unchecked: 'OFF' }"
          style="display: inline-block"
          @change="handleChangeConfig"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { ToggleButton } from 'vue-js-toggle-button'
import { mapGetters } from 'vuex'
import cmsConfig from '@/api/config'
export default {
  components: {
    ToggleButton
  },
  data() {
    return {
      update_timestamp_beacon_not_reply_with_in_second: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  watch: {
    selectedBot(data) {
      const tempValue =
        data.page_custom_attributes_json.update_timestamp_beacon_not_reply_with_in_second || false
      this.update_timestamp_beacon_not_reply_with_in_second = tempValue
    }
  },
  async mounted() {
    await this.$store.dispatch('updateBotDetail')
  },
  methods: {
    async handleChangeConfig() {
      try {
        this.$store.dispatch('loading')
        const response = await cmsConfig.updatePageCustomAttributes({
          params: {
            pageId: this.selectedBot.pageid
          },
          data: {
            page_custom_attributes_json: {
              update_timestamp_beacon_not_reply_with_in_second:
                !this.update_timestamp_beacon_not_reply_with_in_second
            }
          }
        })
        const { status } = response
        if (status === 204) {
          this.$swal.fire({
            type: 'success',
            title: this.$t('Success')
          })
        }
      } catch (error) {
        console.error(error)
        this.$swal.fire({
          type: 'error',
          title: this.$t('Unsuccessful')
        })
      } finally {
        this.$store.dispatch('updateBotDetail')
        this.$store.dispatch('loading')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/Beacon/BeaconSetting.vue